import { type SearchRequest } from '@searchkit/api';

import {
  createResponseFactory,
  type PremiumMarketMoversSearchResponseBody,
} from '~/search-domain/pipelines/premium-market-movers/response-factory';
import { type SearchDomainContext } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/search-domain/utils';

export async function transformPremiumMarketMoversResponse(
  context: SearchDomainContext,
  { searchResponse }: { searchRequest: SearchRequest; searchResponse: PremiumMarketMoversSearchResponseBody },
) {
  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(createResponseFactoryContext(context), elasticContext, searchResponse);
}
